<template>
<div>
  <SignModal></SignModal>
  <TokenExpiryModal></TokenExpiryModal>
  <UserOverrideModal v-if="canUseOverride"></UserOverrideModal>
  <BusinessSwitchModal></BusinessSwitchModal>
  <client-only>
  <div v-if="gtm">
    <!-- Google Tag Manager (noscript) -->
    <noscript id="google-tags"><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P6PJHT"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
  </div>
  </client-only>
</div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '~/store/user'
import env from '~/libs/env'
import get from 'lodash/get'
import SignModal from '~/components/SignModal'
import UserOverrideModal from '~/components/UserOverrideModal.vue'
import BusinessSwitchModal from '~/components/BusinessSwitchModal.vue'
import TokenExpiryModal from '~/components/TokenExpiryModal.vue'
import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import { useBusinessSwitchStore } from '~/store/business-switch'
import { useAppAnalyticsStore } from '~/store/app-analytics'
import { useUserOverrideStore } from '~/store/user-override'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

/**
 * Include this component in any new vue layouts (excluding legacy)
 * Add any shared code here that should exist in all layouts
 */
export default {
  components: {
    SignModal,
    UserOverrideModal,
    BusinessSwitchModal,
    TokenExpiryModal
  },
  watch: {
    '$route.path'() {
      const params = {
			  "view": this.$route.path,
			  "orderId": this.borrowerId,
      }
      useAppAnalyticsStore(this.$pinia).adobeTrackEvent({ mbox: 'event', params })
      useAppAnalyticsStore(this.$pinia).dreamsSetEvent({ name: this.$route.path, value: true })

    },
  },
  props: {
    gtm: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(useRootStore, [
      'pageTitle',
    ]),
    ...mapState(useRootStore, ['authUser', 'canUseEmbedded']),
    ...mapState(useBorrowerStore, {
      borrower: store => get(store, 'borrower', null),
      borrowerId: store => get(store, 'borrowerId', null)
    }),

    ...mapState(useBusinessSwitchStore, {
      businessSwitchModalVisible: store => get(store, 'businessSwitchModalVisible')
    }),

    lendioId() {
      return get(window, 'dreams.dataLayer.user.lendioId', null)
    },
    canUseOverride() {
      return this.borrower && this.borrower.isTest && this.authUser
    }
  },
  setup() {
    const rootStore = useRootStore()
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    rootStore.setPageTitle(affiliateCustomizationsStore.headTitlePrefix + ' - Portal')

    if (!env('useTenantTheme') === true) {
      rootStore.setLendioFavicons()
    } else {
      rootStore.setBlankFavicons()
    }

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
    })
  },
  methods: {
    ...mapActions(useRootStore, [
      'setPageTitle',
      'setLendioFavicons',
      'setBlankFavicons'
    ]),
  },
  async mounted() {
    if (this.canUseOverride) {
      useUserOverrideStore(this.$pinia).initialOverrideSetup()
    } else {
      useUserOverrideStore(this.$pinia).clearAllOverrides()
    }

    if (this.canUseEmbedded && window.lendio && !window.lendio.hasIdentified) {
      const embeddedInitBody = useRootStore(this.$pinia).getEmbeddedInitBody
      window.lendio.initialize(embeddedInitBody)
    }

    const piniaUserStore = useUserStore(this.$pinia)
    await piniaUserStore.getBorrowers()
    await piniaUserStore.loadFreshLogin()
  },
}
</script>

<style lang="scss">
@import 'lendio-modals';

.btn.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(5, 194, 240, 0.5) !important;
}
.btn.btn-primary.next-save {
  box-shadow: none !important;
}
</style>
